'use client';
import { FC } from 'react';

import { FilterListPayload, PlpFilterQueryParams } from '@/types/CarFilters.types';

import { SearchAlertTileLowResults } from '../SearchAlertTile/SearchAlertTileLowResults';
import { SearchAlertTileNoResults } from '../SearchAlertTile/SearchAlertTileNoResults';
import { SearchAlertToggle } from '../SearchAlertToggle/SearchAlertToggle';
import { SearchAlertToggleProvider } from '../SearchAlertToggle/SearchAlertToggleProvider';

type Props = {
  filtersList: FilterListPayload;
  filterParams?: PlpFilterQueryParams;
  sku?: string;
  placement: 'tile' | 'page-top';
  plpSlug: string;
  savedSearchTypesenseQuery: {
    q: string;
    filter_by: string;
    page: number;
  };
};

export const ResultsSearchAlertToggle: FC<Props> = ({
  filterParams,
  filtersList,
  sku,
  placement,
  plpSlug,
  savedSearchTypesenseQuery,
}: Props) => {
  const getToggleComponent = () => {
    if (placement === 'tile') {
      return sku ? SearchAlertTileLowResults : SearchAlertTileNoResults;
    }
    return SearchAlertToggle;
  };

  return (
    <SearchAlertToggleProvider
      filtersList={filtersList}
      filters={filterParams}
      Component={getToggleComponent()}
      placement={placement}
      targetSlug={plpSlug}
      savedSearchTypesenseQuery={savedSearchTypesenseQuery}
    />
  );
};
